import { useMemo } from 'react'
import { useBulkCapabiltiesQuery } from 'hooks/queries/Capabilities/useCapabiltiesQuery'
import { Capabilities, CapabilitiesScope } from 'types/capabilities/capabilities'
import { SourcePayWallet } from '../types'

const useIsB2cPayoutsEnabled = (wallet: SourcePayWallet) => {
  const request = {
    capabilities: [
      {
        group: Capabilities.FIAT_PAYOUTS_B2C.group,
        name: Capabilities.FIAT_PAYOUTS_B2C.name,
        objects: [{ scope: CapabilitiesScope.WALLET, subjectId: wallet?.walletId }],
      },
    ],
  }

  const {
    data: bulkCapabilities,
    isFetching: isFetchingBulkCapabilities,
    isError: isFetchingBulkCapabilitiesError,
  } = useBulkCapabiltiesQuery(request, !!wallet)

  const capabilityValue = useMemo(() => {
    if (isFetchingBulkCapabilitiesError) return false

    if (!isFetchingBulkCapabilities && !!bulkCapabilities) {
      const walletB2cCapability = bulkCapabilities.FIAT.PAYOUTS_B2C.WALLET?.[wallet?.walletId]
      const isWalletB2cPayoutEnabled = walletB2cCapability?.value === 'true'

      return isWalletB2cPayoutEnabled
    }

    return false
  }, [bulkCapabilities, isFetchingBulkCapabilities, isFetchingBulkCapabilitiesError])

  return {
    isB2cPayoutEnabled: capabilityValue,
    isError: isFetchingBulkCapabilitiesError,
    isLoading: isFetchingBulkCapabilities,
  }
}

export default useIsB2cPayoutsEnabled
